import { CardListOneConfigBase } from '@/views/game/components/gameCardSuit2/cardList/listOne'
import { HomeLayoutType } from '@/api/common/type'
import { useMainStore } from '@/store/index'

/** 默认列表布局 */
export class _ListLayoutHome extends CardListOneConfigBase {
  protected initPC(): this {
    this.width = 1154
    this.rowCardCount = 6
    this.leftRightSpacing = 24
    this.topBotSpacing = 24
    return this
  }
  protected initH5(): this {
    const topLayout =
      useMainStore().homeLayoutInfos?.topLayout || HomeLayoutType.style0
    const funMapper = {
      [HomeLayoutType.style0]: () => {
        this.width = 520
        this.rowCardCount = 3
        this.leftRightSpacing = 20
        this.topBotSpacing = 20
      },
      [HomeLayoutType.style1]: () => {
        this.width = 690
        this.rowCardCount = 3
        this.leftRightSpacing = 30
        this.topBotSpacing = 30
      }
    }
    funMapper[topLayout]()
    return this
  }
}
